
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Calendar, CheckCircle, XCircle, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import BaseWidget from './BaseWidget';

interface AppointmentStatusWidgetProps {
  id: string;
  index: number;
  appointmentsTotal: number;
  appointmentsCompleted: number;
  appointmentsNoShow: number;
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
}

const AppointmentStatusWidget = ({ 
  id, 
  index, 
  appointmentsTotal, 
  appointmentsCompleted, 
  appointmentsNoShow, 
  isCollapsed, 
  onToggleCollapse 
}: AppointmentStatusWidgetProps) => {
  const appointmentsPending = appointmentsTotal - appointmentsCompleted - appointmentsNoShow;

  return (
    <BaseWidget
      id={id}
      title="🧖‍♀️ Appointment Status"
      index={index}
      isCollapsed={isCollapsed}
      onToggleCollapse={onToggleCollapse}
    >
      <div className="space-y-4">
        <div className="text-center">
          <div className="text-2xl font-bold text-juv-deep-chestnut">
            {appointmentsTotal} appointments today
          </div>
        </div>

        <div className="grid grid-cols-3 gap-4">
          <div className="text-center">
            <Badge className="w-full bg-green-100 text-green-800 hover:bg-green-100">
              <CheckCircle className="h-3 w-3 mr-1" />
              {appointmentsCompleted} Showed
            </Badge>
          </div>
          <div className="text-center">
            <Badge className="w-full bg-red-100 text-red-800 hover:bg-red-100">
              <XCircle className="h-3 w-3 mr-1" />
              {appointmentsNoShow} No-Show
            </Badge>
          </div>
          <div className="text-center">
            <Badge className="w-full bg-juv-soft-blush text-juv-deep-chestnut hover:bg-juv-soft-blush">
              <Clock className="h-3 w-3 mr-1" />
              {appointmentsPending} Pending
            </Badge>
          </div>
        </div>

        <Button asChild variant="outline" className="w-full">
          <Link to="/staff/appointments" className="flex items-center">
            <Calendar className="h-4 w-4 mr-2" />
            View Full Calendar
          </Link>
        </Button>
      </div>
    </BaseWidget>
  );
};

export default AppointmentStatusWidget;
